import { render, staticRenderFns } from "./mobile-upload.vue?vue&type=template&id=538b4c32&scoped=true"
import script from "./mobile-upload.vue?vue&type=script&lang=ts"
export * from "./mobile-upload.vue?vue&type=script&lang=ts"
import style0 from "./mobile-upload.vue?vue&type=style&index=0&id=538b4c32&prod&lang=less&scoped=true"
import style1 from "./mobile-upload.vue?vue&type=style&index=1&id=538b4c32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b4c32",
  null
  
)

export default component.exports